package com.gsb.vyapar.bhagya.presentation.navigation.manager

import com.gsb.vyapar.bhagya.presentation.navigation.event.NavigationUiEvents
import com.gsb.vyapar.bhagya.presentation.navigation.event.NavigationUiEvents.*
import com.gsb.vyapar.bhagya.presentation.navigation.util.*

object NavigationManager {
    fun onTriggerEvent(event: NavigationUiEvents) {
        when(event) {
            PopView -> popView()
            is PushView -> pushView(event.screen)
        }
    }
}